(function () {
  var STORAGE_KEY = 'duntery_recently_viewed';
  var MAX_ITEMS = 10;

  function readHandles() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeHandles(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_ITEMS)));
    } catch (e) {}
  }

  function trackCurrent(handle) {
    if (!handle) return;
    var handles = readHandles().filter(function (item) {
      return item && item !== handle;
    });
    handles.unshift(handle);
    writeHandles(handles);
  }

  function money(cents) {
    if (typeof cents !== 'number') return '';
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function imageSrc(product, width) {
    var img =
      product.featured_image ||
      (product.images && product.images[0]) ||
      '';
    if (!img) return '';
    if (typeof img === 'object') {
      img = img.src || img.url || '';
    }
    if (!img) return '';
    // Prefer a sized CDN URL for portrait cards
    if (img.indexOf('?') === -1) {
      return img.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_' + width + 'x$1$3');
    }
    return img + (img.indexOf('width=') === -1 ? '&width=' + width : '');
  }

  function escapeAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function renderPriceHtml(product) {
    var price = money(product.price);
    var compare =
      product.compare_at_price && product.compare_at_price > product.price
        ? money(product.compare_at_price)
        : '';

    if (compare) {
      return (
        '<div class="price price--on-sale">' +
        '<div class="price__container">' +
        '<div class="price__regular">' +
        '<span class="price-item price-item--regular">' +
        price +
        '</span></div>' +
        '<div class="price__sale">' +
        '<s class="price-item price-item--regular">' +
        compare +
        '</s>' +
        '<span class="price-item price-item--sale price-item--last">' +
        price +
        '</span></div></div></div>'
      );
    }

    return (
      '<div class="price">' +
      '<div class="price__container">' +
      '<div class="price__regular">' +
      '<span class="price-item price-item--regular">' +
      price +
      '</span></div></div></div>'
    );
  }

  function withRoot(rootUrl, path) {
    var root = String(rootUrl || '/').replace(/\/$/, '');
    var normalized = String(path || '');
    if (normalized.charAt(0) !== '/') normalized = '/' + normalized;
    return root + normalized;
  }

  function renderCard(product, imageRatio, rootUrl) {
    var ratio = imageRatio === 'square' ? 1 : 0.67;
    var ratioPercent = (100 / ratio).toFixed(2) + '%';
    var img = imageSrc(product, 600);
    var title = product.title || '';
    var href = withRoot(rootUrl, '/products/' + encodeURIComponent(product.handle || ''));

    return (
      '<li class="product-reco-scroll__item">' +
      '<div class="card-wrapper underline-links-hover">' +
      '<div class="card card--standard card--media" style="--ratio-percent: ' +
      ratioPercent +
      ';">' +
      '<div class="card__inner ratio" style="--ratio-percent: ' +
      ratioPercent +
      ';">' +
      (img
        ? '<div class="card__media"><div class="media media--transparent">' +
          '<img src="' +
          escapeAttr(img) +
          '" alt="' +
          escapeAttr(title) +
          '" loading="lazy" width="400" height="600" class="motion-reduce">' +
          '</div></div>'
        : '') +
      '</div>' +
      '<div class="card__content">' +
      '<div class="card__information">' +
      '<h3 class="card__heading h3">' +
      '<a href="' +
      href +
      '" class="full-unstyled-link">' +
      escapeHtml(title) +
      '</a></h3>' +
      '<div class="card-information">' +
      renderPriceHtml(product) +
      '</div></div></div></div></div></li>'
    );
  }

  function initSection(section) {
    var current = section.getAttribute('data-product-handle');
    var rootUrl = section.getAttribute('data-root-url') || '/';
    var limit = parseInt(section.getAttribute('data-limit') || '5', 10);
    var imageRatio = section.getAttribute('data-image-ratio') || 'portrait';
    var list = section.querySelector('[data-recently-viewed-list]');
    var empty = section.querySelector('[data-recently-viewed-empty]');
    if (!list) return;

    var handles = readHandles().filter(function (handle) {
      return handle && handle !== current;
    }).slice(0, limit);

    if (!handles.length) {
      section.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch(withRoot(rootUrl, '/products/' + encodeURIComponent(handle) + '.js'))
          .then(function (res) {
            if (!res.ok) throw new Error('missing');
            return res.json();
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var html = products
        .filter(Boolean)
        .map(function (product) {
          return renderCard(product, imageRatio, rootUrl);
        })
        .join('');

      if (!html) {
        section.hidden = true;
        return;
      }

      list.innerHTML = html;
      section.hidden = false;
      section.classList.add('product-recommendations--loaded');
    });
  }

  function syncAfterProductAjax(detail) {
    var section =
      (detail && detail.section) ||
      document.querySelector('[data-main-product-section]');
    var handle =
      (section && section.getAttribute('data-product-handle')) ||
      '';

    if (handle) {
      trackCurrent(handle);
      var trackEl = document.querySelector('[data-recently-viewed-track]');
      if (trackEl) trackEl.setAttribute('data-product-handle', handle);
      document.querySelectorAll('[data-recently-viewed]').forEach(function (el) {
        el.setAttribute('data-product-handle', handle);
        initSection(el);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var trackEl = document.querySelector('[data-recently-viewed-track]');
    if (trackEl) {
      trackCurrent(trackEl.getAttribute('data-product-handle'));
    }

    document.querySelectorAll('[data-recently-viewed]').forEach(initSection);
  });

  document.addEventListener('product:ajax-loaded', function (event) {
    syncAfterProductAjax(event && event.detail);
  });
})();
